import { ConnectedTabsWorkspace } from 'components/shared/DragAndDropWorkspace/TabsWorkspace';
import { FC } from 'react';

import type { SecondaryMarketPostEventTabType } from '../../../state/workspaces/model';
import { EmptyWorkspace } from '../PrimaryPostTrade/Tabs';
import { SecondaryMarketPostEventTab } from './Tabs';

export const SecondaryMarketPostEventWorkspace: FC = () => (
  <ConnectedTabsWorkspace workspace="secondaryMarketPostEvents" onAddNewTab={undefined}>
    {tab =>
      tab === null ? (
        <EmptyWorkspace />
      ) : (
        <SecondaryMarketPostEventTab tabId={tab.id} tabType={tab.type as SecondaryMarketPostEventTabType} />
      )
    }
  </ConnectedTabsWorkspace>
);

SecondaryMarketPostEventWorkspace.displayName = 'SecondaryMarketPostEventWorkspace';
